"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const loader_1 = require("@googlemaps/loader");
const logger_1 = __importDefault(require("../helper/logger"));
exports.default = (props) => {
    const { language, libraries, region, apiKey } = props;
    const [mapLoader, setLoad] = react_1.useState(false);
    react_1.useEffect(() => {
        const loader = new loader_1.Loader(Object.assign(Object.assign(Object.assign({ apiKey }, (language ? { language: language } : {})), (region ? { region: region } : {})), (libraries ? { libraries: libraries } : {})));
        loader
            .load()
            .then(() => {
            setLoad(true);
        })
            .catch(() => {
            logger_1.default.error('Google map init error');
        });
    }, [apiKey, libraries, setLoad, language, region]);
    return { mapLoader };
};
